/**
 * Downloads a URL
 * @param {string} url URL
 * @param {string} filename File's name
 */
export function fromURL (url, filename) {
  const target = document.createElement('a')
  target.href = url
  target.download = filename
  target.rel = 'noopener'
  target.dispatchEvent(new MouseEvent('click'))
}

/**
 * Downloads a blob
 * @param {Blob} blob Blob
 * @param {string} filename File's name
 */
export function fromBlob (blob, filename) {
  fromURL(URL.createObjectURL(blob), filename)
}

export default {
  fromURL,
  fromBlob
}
